import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';

export class EmploymentMotiveService {
   async getEmploymentMotives() {
      return await http.get('/employment-motives', cacheFirstConfig).then((response: any) => {
         return response.data.data;
      });
   }
}
